<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('users')">Benutzer</inertia-link>
        <span class="kreditgenie-text-green font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block w-8 h-8 rounded-full ml-4" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore">
      Dieser Benutzer wurde gelöscht.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Vorname" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nachname" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Passwort" />
          <textarea-input v-model="form.bio" :error="form.errors.bio" class="pr-6 pb-8 w-full" label="Bio" />
          <select-input v-model="form.owner" :error="form.errors.owner" class="pr-6 pb-8 w-full lg:w-1/2" label="Eigentümer">
            <option :value="true">Ja</option>
            <option :value="false">Nein</option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Foto" />
          <select-input v-model="form.is_on_homepage" :error="form.errors.is_on_homepage" class="pr-6 pb-8 w-full lg:w-1/2" label="Auf der Startseite anzeigen?">
            <option :value="true">Ja</option>
            <option :value="false">Nein</option>
          </select-input>
          <select-input v-model="form.user_function" :error="form.errors.is_on_homepage" class="pr-6 pb-8 w-full lg:w-1/2" label="Benutzerfunktion?">
            <option v-for="functionItem in userFunctions" :key="functionItem" :value="functionItem">
              {{ functionItem }}
            </option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Löschen</button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">Aktualisieren</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '../../Shared/TextareaInput'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  components: {
    TextareaInput,
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    userFunctions: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'post',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: null,
        owner: this.user.owner,
        photo: null,
        bio: this.user.bio,
        is_on_homepage: this.user.is_on_homepage,
        user_function: this.user.user_function,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(this.route('users.update', this.user.id).url(), {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Möchten Sie diesen Benutzer wirklich löschen?')) {
        this.$inertia.delete(this.route('users.destroy', this.user.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie diesen Benutzer wirklich wiederherstellen?')) {
        this.$inertia.put(this.route('users.restore', this.user.id))
      }
    },
  },
}
</script>
